import { useQuery } from '@tanstack/react-query';

import { carFinanceApi } from '../../../../api/carFinanceApi';
import {
  type LoanRequest,
  loanRequestSchema,
  loanResponseSchema,
} from '../schema/carFinance.schema';
import { PAGE } from '../../../../helpers/pages';

export const USE_CAR_FINANCE_LOAN = ['carFinanceLoan'];

const calculateLoan = async (payload: LoanRequest) => {
  const { data } = await carFinanceApi.loan(payload);

  return loanResponseSchema.parse(data);
};

type UseCarFinanceLoanArgs = {
  options: LoanRequest;
  dependencies: Array<number>;
  /**
   * To avoid making unnecessary API calls, we should only request loan details when a valid
   * deposit amount is provided
   */
  enabled: boolean;
};

export const useCarFinanceLoan = (args: UseCarFinanceLoanArgs) => {
  const { options, enabled, dependencies } = args;

  return useQuery({
    queryKey: [...USE_CAR_FINANCE_LOAN, ...dependencies],
    queryFn: () => {
      const payload = loanRequestSchema.parse(options);
      return calculateLoan(payload);
    },
    meta: { tags: [PAGE.CAR_FINANCE] },
    enabled,
  });
};
